<div class="wrapper wrapper-full-page">
  <div class="full-page login-page">
      <div class="content">
          <div class="container">
              <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
                  <div class="card">
                      <div class="header text-center">
                          <h2 class="card-title d-flex align-items-center justify-content-center">Change Password</h2>
                          <p class="sub-title">Enter your current password to reset the password</p>
                      </div>
                      <div class="content">
                          <div class="form-group">
                              <label>Current Password</label>
                              <div class="input-wrapper">
                                  <input [type]="showCurrentPassword ? 'text' : 'password'" formControlName="currentPassword" autocomplete="current-password" />
                                  <span class="eye-icon" (click)="toggleCurrentPassword()">
                                      <img 
                                          [src]="showCurrentPassword ? 'assets/img/eye-closed.svg' : 'assets/img/eye.svg'" 
                                          alt="Toggle visibility"
                                          class="eye-image"/>
                                  </span>
                              </div>
                              <div class="error-message" *ngIf="currentPassword?.touched && currentPassword?.invalid">
                                  <span *ngIf="currentPassword?.errors?.['required']">Password is required</span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label>New Password</label>
                            <div class="input-wrapper">
                                <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" autocomplete="new-password" />
                                <span class="eye-icon" (click)="toggleNewPassword()">
                                    <img 
                                        [src]="showNewPassword ? 'assets/img/eye-closed.svg' : 'assets/img/eye.svg'" 
                                        alt="Toggle visibility"
                                        class="eye-image"/>
                                </span>
                            </div>
                            <div class="error-message" *ngIf="newPassword?.touched && newPassword?.invalid">
                                <span *ngIf="newPassword?.errors?.['required']">New Password is required</span>
                                <span *ngIf="newPassword?.errors?.['minlength']">New Password must be at least {{ newPassword?.errors?.['minlength']?.requiredLength }} characters</span>
                            </div>
                        </div>
                              <div class="form-group">
                              <label>Confirm New Password</label>
                              <div class="input-wrapper">
                                    <input [type]="showConfirmPassword ? 'text' : 'password'" 
                                      formControlName="confirmPassword" autocomplete="new-password" />
                                  <span class="eye-icon" (click)="toggleConfirmPassword()">
                                      <img [src]="showConfirmPassword ? 'assets/img/eye-closed.svg' : 'assets/img/eye.svg'"
                                          alt="Toggle visibility" class="eye-image" />
                                  </span>
                              </div>
                              <div class="error-message" *ngIf="confirmPassword?.touched && confirmPassword?.invalid">
                                  <span *ngIf="confirmPassword?.errors?.['required']">Confirm New Password is required</span>
                                  <span *ngIf="confirmPassword?.errors?.['minlength']">Confirm New Password must be at least {{ confirmPassword?.errors?.['minlength']?.requiredLength }} characters</span>
                                  <span *ngIf="confirmPassword?.errors?.['passwordMismatch']">Passwords do not match</span>
                              </div>                          
                          </div>
                      </div>
                      <div class="footer text-center">
                          <button type="submit" class="d-block btn btn-color btn-wd" [disabled]="isLoading">
                              <span *ngIf="!isLoading">Change New Password</span>
                              <span *ngIf="isLoading">Changing Password...</span>
                          </button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
  </div>
</div>
